export default {
  namespaced: true,
  users_rh: {
    title: "Usuarios Rh",
    soeid: "SOEID",
    name: "Nome",
    first_name: "Primeiro nome",
    second_name: "Segundo nome",
    email: "Email",
  }
};